import ProductInformation from './ProductInformation';

export default ProductInformation;
